var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.compBackgroundColor)},[(_vm.$store.state.user.role)?_c('SideNav'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }